// alert.js를 가장 먼저 import하여 window.alert 오버라이드가 먼저 실행되도록 함
import './utils/alert';
import { registerChunkLoadRecovery } from './chunkLoadRecovery';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 배포·캐시 불일치 시 lazy chunk 404 — ChunkLoadError 1회 자동 복구(전체 리로드)
registerChunkLoadRecovery();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



